import { APITransport } from '@client/transports/api';

export const MessagesService = {
  async get(query = { days: 30 }) {
    const response = await APITransport.post({
      path: '/rest/user/report/allmsgdata',
      query
    });

    return Array.isArray(response) ? response : [];
  },
  getMessageData(id) {
    return APITransport.get({
      path: '/rest/user/report/msgdata',
      query: {
        msglink: id
      }
    });
  },
  people(query = { email }) {
    return APITransport.get({
      baseURL: '',
      path: '/api/v1/clearbit/people',
      query
    });
  },
  report(body) {
    return APITransport.post({
      path: '/rest/user/execute/reportscanner',
      body
    });
  }
};
